module.exports = __webpack_public_path__ + "assets/alert-icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alert-icon.png
// module id = 1654
// module chunks = 7